import type { StoreAbortController } from '.';

const assistantMessageIdGetters = new WeakMap<StoreAbortController, () => string | undefined>();

export const activeAssistantMessageIds = {
	register(
		storeAbortController: StoreAbortController,
		getAssistantMessageId: () => string | undefined,
	): void {
		assistantMessageIdGetters.set(storeAbortController, getAssistantMessageId);
	},
	get(storeAbortController: StoreAbortController): string | undefined {
		return assistantMessageIdGetters.get(storeAbortController)?.();
	},
};
